import { ZETRIX_RESPONSE_MESSAGE } from "./requestEnum";
import {
  mainChainId,
  chainIdMessage,
  testChainIdMessage,
  switchAccountIdMessage,
} from "./dictionary";
import { mapMutations } from "vuex";
import ZetrixWalletConnect from "zetrix-connect-wallet-sdk";
import { isMobile, isChrome } from "./util";
import { eventBus } from '@/utils/eventBus';

export default {
  data() {
    return {
      ztx: window.zetrix,
      isMobile: false,
      isChrome: false,
      zetrixWalletConnect: new ZetrixWalletConnect({ qrcode: false }),
      zetrixAccount: sessionStorage.getItem("zetrixAccount"),
      balance: this.$store.state.balance,
      isLogin: sessionStorage.getItem("isLogin"),
      errorNetwork: "",
    };
  },

  watch: {
    ztx: {
      deep: true,
      handler: function () {
        this.ztx.on("chainChanged", (res) => {
          if (res.code === 0) {
            this.setChainId(res.data.chainId);
            if (!this.isMainNetwork()) {
              this.disconnectWalletZtx();
            }
          }
        });
        this.ztx.on("switchAccount", (res) => {
          if (res.code === 0) {
            this.zetrixAccount = res.data.address;
            if (
              this.zetrixAccount !== sessionStorage.getItem("zetrixAccount")
            ) {
              //this.getAccountBalance(this.zetrixAccount);
              // sessionStorage.clear();
              // sessionStorage.setItem("zetrixAccount", this.zetrixAccount);
              // this.setHeaderMessage({
              //   show: true,
              //   message: switchAccountIdMessage,
              // });
              // this.isLogin = "true";
              // sessionStorage.setItem("isLogin", this.isLogin);
              // setTimeout(() => {
              //   window.location.href = "/#/certificate";
              // }, 2000);
               eventBus.triggerSessionTimeout();
            }
          }
        });
      },
    },
  },

  mounted() {
    this.isMobile = isMobile();
    this.isChrome = isChrome();
    this.checkBalanceZTX();
    this.checkMobileApp();
 
  },

  updated() {
    this.checkWindowZetrix();
  },

  methods: {
    ...mapMutations([
      "setLogin",
      "setHeaderMessage",
      "setChainId",
      "setBalance",
    ]),

    checkWindowZetrix() {
      if (typeof window.zetrix !== undefined) {
        this.ztx = window.zetrix;
      }
    },

    checkMobileApp() {
      if (this.isMobile || !this.isChrome) {
        this.zetrixWalletConnect.connect();
      }
    },

    checkBalanceZTX() {
      if (this.zetrixAccount !== null) {
        //this.getAccountBalance(this.zetrixAccount);
      }
    },

    // 检查zetrix是否安装
    checkZetrixInstall() {
      if (this.isMobile) {
        // use connect wallet
        this.connectWalletMobileZetrix();
      } else if (this.isChrome) {
        if (typeof window.zetrix === undefined) {
          alert("Zetrix Wallet not detected, please install and try again");
          if (
            window.confirm(
              "Proceed to open download page for Zetrix wallet extension?"
            )
          ) {
            window.open(
              "https://chrome.google.com/webstore/detail/zetrix-wallet-extension/faobkiaokccpmnhhefnobkbhnfjmbemh/"
            );
          }
        } else {
          this.ztx = window.zetrix;
          this.ztx.getChainId((res) => {
            if (res.code === 0) {
              this.setChainId(res.data.chainId);
              this.sendClientAuthorize();
            }
          });
        }
      } else {
        this.zetrixWalletConnect = new ZetrixWalletConnect({ qrcode: true });
        this.connectWalletMobileZetrix();
      }
    },

    sendClientAuthorize() {
      if (!this.isMainNetwork()) {
        this.$store.dispatch("triggerSnackbar", this.errorNetwork);
        return false;
      }
      this.ztx.authorize({ method: "changeAccounts" }, async  (resp) => {
        if (resp.code === 0) {
          this.authBlob(resp.data.address).then((blob) => {
            if (!blob) {
              console.error("Failed to get blob");
              return;
            }

             this.ztx.authorize(
              { method: "sendRandom", param: { random: blob } },
              async (resAuth) => {
                if (resAuth.code === 0) {

                  // Step 3: Call authLogin
                  this.authLogin(
                    resp.data.address,
                    resAuth.data.signData, // signBlob
                    resAuth.data.publicKey
                  ).then(async (accessToken) => {
                    if (accessToken) {
                      sessionStorage.setItem("zetrixAccount", resp.data.address);
                      sessionStorage.setItem("publicKey", resAuth.data.publicKey);

                      window.dispatchEvent(new Event("account-connected"));

                      this.zetrixAccount = resp.data.address;
                      //this.getAccountBalance(this.zetrixAccount);
                      this.isLogin = "true";
                      sessionStorage.setItem("isLogin", this.isLogin);
                      // ✅ Step 4: Check KYC status

                      if (sessionStorage.getItem("userRole") === "ISSUER") {
                        this.statusKyc().then(async (status) => {
                          if (!status) {
                            sessionStorage.setItem("kyc", status);
                            this.$router.push("/kyc-application");
                            return;
                          }

                          switch (status) {
                            case "PENDING":
                            case "REJECTED":
                            case "REVOKED":
                              sessionStorage.setItem("kyc", status);
                              this.$router.push("/kyc-status");
                              break;
                            case "ACTIVE":
                             // Fetch KYC details + user details concurrently
                              const [kycDetails, userInfo] = await Promise.all([
                                this.statusDetails({ address: this.zetrixAccount }),
                                this.userDetails(this.zetrixAccount)
                              ]);

                              sessionStorage.setItem("kyc", status);

                              if (userInfo?.object?.name) {
                                sessionStorage.setItem("userName", userInfo.object.name);
                              }
                              if (kycDetails?.object?.user?.name) {
                                sessionStorage.setItem("companyName", kycDetails?.object?.user?.name);
                              }

                              this.$router.push("/certificate");
                              break;
                            default:
                              sessionStorage.setItem("kyc", status);
                              this.$router.push("/kyc-application");
                              console.warn("Unknown KYC status:", status);
                          }
                        });
                      }


                      if (sessionStorage.getItem("userRole") == "MAKER") {

                        // Fetch KYC details + user details concurrently
                        const [kycDetails, userInfo] = await Promise.all([
                          this.statusDetails({ address: this.zetrixAccount }),
                          this.userDetails(this.zetrixAccount)
                        ]);

                        if (userInfo?.object?.name) {
                          sessionStorage.setItem("userName", userInfo.object.name);
                            
                        }
                        if (kycDetails?.object?.user?.name) {
                          sessionStorage.setItem("companyName", kycDetails?.object?.user?.name);
                        }

                        sessionStorage.setItem("kyc", "ACTIVE");

                        this.$router.push("/certificate");


                      
                      }

                      if (sessionStorage.getItem("userRole") == "ADMIN") {

                        // Fetch KYC details + user details concurrently
                        const [kycDetails, userInfo] = await Promise.all([
                          this.statusDetails({ address: this.zetrixAccount }),
                          this.userDetails(this.zetrixAccount)
                        ]);

                        if (userInfo?.object?.name) {
                          sessionStorage.setItem("userName", userInfo.object.name);
                            
                        }
                        if (kycDetails?.object?.user?.name) {
                          sessionStorage.setItem("companyName", kycDetails?.object?.user?.name);
                        }

                        sessionStorage.setItem("kyc", null);

                        this.$router.push("/issuer/application-list");


                      
                      }

                    } else {
                      console.error("authLogin failed: no token returned");
                    }
                  });
                }
              }
            );
          });

        } else {
          switch (resp.code) {
            case 1:
              alert(ZETRIX_RESPONSE_MESSAGE.CANCEL);
              break;
            case -1:
              alert(ZETRIX_RESPONSE_MESSAGE.FAIL);
              break;
            case 100001:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100001);
              break;
            case 100002:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100002);
              break;
            case 100003:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100003);
              break;
            case 100004:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100004);
              break;
          }
        }
      });
    },

    isMainNetwork() {
    
      const chainId = this.$store.state.chainId;
      const host = `${window.location.protocol}//${window.location.host}`;
      const url = process.env.VUE_APP_API_BASE_URL;
      if (
        (host.includes("localhost") ||
          host.includes("test") ||
          host.includes("dev") ||
          host.includes("sandbox") ||
          url.includes("localhost") ||
          url.includes("test") ||
          url.includes("dev") ||
          url.includes("sandbox")) &&
        chainId === mainChainId
      ) {
        this.setHeaderMessage({
          show: true,
          message: testChainIdMessage,
        });
        this.errorNetwork = testChainIdMessage;
        return false;
      } else if (
        !host.includes("localhost") &&
        !host.includes("test") &&
        !host.includes("dev") &&
        !host.includes("sandbox") &&
        !url.includes("localhost") &&
        !url.includes("test") &&
        !url.includes("dev") &&
        !url.includes("sandbox") &&
        chainId !== mainChainId
      ) {
        this.setHeaderMessage({
          show: true,
          message: chainIdMessage,
        });
        this.errorNetwork = chainIdMessage;
        return false;
      }
      this.setHeaderMessage({
        show: false,
        message: "",
      });
      return true;
    },

    connectWalletMobileZetrix() {
      this.zetrixWalletConnect
        .connect()
        .then((res) => {
          this.zetrixWalletConnect
            .auth()
            .then((res) => {
              sessionStorage.setItem("zetrixAccount", res.data.address);
              this.zetrixAccount = res.data.address;
              //this.getAccountBalance(this.zetrixAccount);
              this.isLogin = "true";
              sessionStorage.setItem("isLogin", this.isLogin);
              window.location.href = "/#/certificate";
            })
            .catch(() => {
              return false;
            });
        })
        .catch(() => {
          return false;
        });
    },

    getAccountBalance(zetrixAccount) {
      this.$store
        .dispatch("wallet/getAccountBalance", { zetrixAccount: zetrixAccount })
        .then((response) => {
          if (response != null) {
            this.setBalance(response.balance);
            this.balance = response.balance;
          } else {
            this.setBalance(0);
            this.balance = 0;
          }
        });
    },

    signBlob(blob) {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (typeof this.ztx !== undefined) {
            this.ztx.signMessage({ message: blob }, function (result) {
              if (result.code === 0) {
                return resolve(result);
              }
              return resolve(false);
            });
          } else {
            return resolve(false);
          }
        }, 0);
      });
    },

    signBlobMobileZtx(blob) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.zetrixWalletConnect
            .signBlob({ message: blob })
            .then((res) => {
              if (res.code === 0) {
                return resolve(res);
              } else {
                return resolve(false);
              }
            })
            .catch((e) => {
              return resolve(false);
            });
        }, 0);
      });
    },

    disconnectWalletZtx() {
      if (this.isMobile || !this.isChrome) {
        this.zetrixWalletConnect.disconnect();
      }
      window.location.href = "/";
      sessionStorage.clear();
      localStorage.clear()
    },

    authBlob(address) {
      return this.$store.dispatch("issuer/authBlob", { address }).then((blob) => {
        return blob || null;
      });
    },

    authLogin(address, signBlob, publicKey) {
      return this.$store
        .dispatch("issuer/authLogin", { address, signBlob, publicKey })
        .then((accessToken) => {
          return accessToken || null;
        });
    },

    statusKyc(data) {
      return this.$store.dispatch("issuer/statusKyc", data).then((status) => {
        return status || null; // status can be null or PENDING/ACTIVE/etc.
      });
    },

    async userDetails(data) {
      return this.$store.dispatch("users/userDetail", data).then(async (res) => {
        return res || null; 
      });
    },


    async statusDetails(data) {
      return this.$store.dispatch("issuer/kycDetails",data).then(async (res) => {
        return res || null; 
      });
    },

    templateBlob(data) {
      return this.$store.dispatch("issuer/templateBlob", { data }).then((blob) => {
        return blob || null;
      });
    },

    connectViaMobile(){
      if (this.isMobile) {
        // use connect wallet
        this.connectWalletMobileZetrixV2();
      }else{
        this.zetrixWalletConnect = new ZetrixWalletConnect({ qrcode: true });
        this.connectWalletMobileZetrixV2();
      }
    },

    async connectWalletMobileZetrixV2() {
      try {
        // Step 1: Connect
        await this.zetrixWalletConnect.connect();

        // Step 2: Auth
        const resAuthInit = await this.zetrixWalletConnect.auth();
        if (!resAuthInit || resAuthInit.code !== 0) {
          console.error("Auth failed", resAuthInit);
          return false;
        }

        const address = resAuthInit.data.address;

        // Step 3: Get blob
        const blob = await this.authBlob(address);
        if (!blob) {
          console.error("Failed to get blob");
          return false;
        }

        // Step 4: Sign blob
        const resAuth = await this.zetrixWalletConnect.signBlob({ message: blob });
        console.log("resAuth:", resAuth);

        if (resAuth.code !== 0) {
          console.error("signBlob failed:", resAuth.message);
          return false;
        }

        // Step 5: Call authLogin
        const accessToken = await this.authLogin(
          address,
          resAuth.data.signData,
          resAuth.data.publicKey
        );

        if (!accessToken) {
          console.error("authLogin failed: no token returned");
          return false;
        }

        // Step 6: Store session
        sessionStorage.setItem("zetrixAccount", address);
        sessionStorage.setItem("publicKey", resAuth.data.publicKey);

        window.dispatchEvent(new Event("account-connected"));

        this.zetrixAccount = address;
        this.isLogin = "true";
        sessionStorage.setItem("isLogin", this.isLogin);

        // Step 7: Role-based routing
        await this.handleKycByRole();

        return true;
      } catch (error) {
        console.error("connectWalletMobileZetrixV2 error:", error);
        return false;
      }
    },

    async handleKycByRole() {
      const role = sessionStorage.getItem("userRole");

      if (role === "ISSUER") {
        const status = await this.statusKyc();
        if (!status) {
          sessionStorage.setItem("kyc", status);
          this.$router.push("/kyc-application");
          return;
        }

        switch (status) {
          case "PENDING":
          case "REJECTED":
          case "REVOKED":
            sessionStorage.setItem("kyc", status);
            this.$router.push("/kyc-status");
            break;
          case "ACTIVE": {
            const [kycDetails, userInfo] = await Promise.all([
              this.statusDetails({ address: this.zetrixAccount }),
              this.userDetails(this.zetrixAccount),
            ]);

            sessionStorage.setItem("kyc", status);

            if (userInfo?.object?.name) {
              sessionStorage.setItem("userName", userInfo.object.name);
            }
            if (kycDetails?.object?.user?.name) {
              sessionStorage.setItem("companyName", kycDetails?.object?.user?.name);
            }

            this.$router.push("/certificate");
            break;
          }
          default:
            sessionStorage.setItem("kyc", status);
            this.$router.push("/kyc-application");
            console.warn("Unknown KYC status:", status);
        }
      }

      if (role === "MAKER") {
        const [kycDetails, userInfo] = await Promise.all([
          this.statusDetails({ address: this.zetrixAccount }),
          this.userDetails(this.zetrixAccount),
        ]);

        if (userInfo?.object?.name) {
          sessionStorage.setItem("userName", userInfo.object.name);
        }
        if (kycDetails?.object?.user?.name) {
          sessionStorage.setItem("companyName", kycDetails?.object?.user?.name);
        }

        sessionStorage.setItem("kyc", "ACTIVE");
        this.$router.push("/certificate");
      }

      if (role === "ADMIN") {
        const [kycDetails, userInfo] = await Promise.all([
          this.statusDetails({ address: this.zetrixAccount }),
          this.userDetails(this.zetrixAccount),
        ]);

        if (userInfo?.object?.name) {
          sessionStorage.setItem("userName", userInfo.object.name);
        }
        if (kycDetails?.object?.user?.name) {
          sessionStorage.setItem("companyName", kycDetails?.object?.user?.name);
        }

        sessionStorage.setItem("kyc", null);
        this.$router.push("/issuer/application-list");
      }
    },

    async signBlobMobileZtxV2(blob) {
      try {
        console.log("signBlobMobileZtxV2 blob:", blob);
        const res = await this.zetrixWalletConnect.signBlob({ message: blob });
         console.log("signBlobMobileZtxV2 result:", res);
        if (res.code === 0) {
          return res; // { code, data }
        } else {
          console.error("signBlobMobileZtx error:", res.message);
          return { code: res.code || -1, message: res.message || "Sign failed" };
        }
      } catch (error) {
        console.error("signBlobMobileZtx exception:", error);
        return { code: -1, message: "Unexpected error while signing" };
      }
    }

    
   
  },
};
